








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { HealthStatusDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxHealthStatus extends Vue {
  private types: HealthStatusDto[] | null = [];
  public selectedType = new HealthStatusDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: HealthStatusDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: HealthStatusDto) {
    this.$emit("healthStatusSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .healthStatus_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
